export default "__VITE_ASSET__BlZLGY1V__"